var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "url(#paint0_radial_5258_1607)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.69,
    cy: 44.69,
    r: 39.7603,
    fill: "url(#paint1_radial_5258_1607)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.692,
    cy: 44.692,
    r: 26.8151,
    fill: "#1BA397"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 25.3125L49.4062 28.6875L54.8438 27.9375L56.9062 33.0938L62.0625 35.1562L61.3125 40.5937L64.6875 45L61.3125 49.4062L62.0625 54.8438L56.9062 56.9062L54.8438 62.0625L49.4062 61.3125L45 64.6875L40.5937 61.3125L35.1562 62.0625L33.0938 56.9062L27.9375 54.8438L28.6875 49.4062L25.3125 45L28.6875 40.5937L27.9375 35.1562L33.0938 33.0938L35.1562 27.9375L40.5937 28.6875L45 25.3125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8164 48.4668V47.1191C42.8018 45.1855 43.7393 43.8672 45.7461 42.666C47.4453 41.626 48.1045 40.7031 48.1045 39.1504V39.1211C48.1045 37.3193 46.6982 35.9863 44.5156 35.9863C42.3037 35.9863 40.8975 37.29 40.751 39.3701L40.7217 39.3848L38.2314 39.3994V39.3701C38.3926 36.2207 40.502 33.7012 44.6182 33.7012C48.3096 33.7012 50.8291 35.9863 50.8291 38.9893V39.0186C50.8291 41.3037 49.6426 42.9297 47.7676 44.0576C45.9072 45.1562 45.3799 45.9766 45.3799 47.5146V48.4668H42.8164ZM44.2959 55.2637C43.1094 55.2637 42.2598 54.4141 42.2598 53.2275C42.2598 52.0264 43.1094 51.1768 44.2959 51.1768C45.4824 51.1768 46.3174 52.0264 46.3174 53.2275C46.3174 54.4141 45.4824 55.2637 44.2959 55.2637Z",
    fill: "#1BA397"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5258_1607",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45 45) rotate(90) scale(45)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#1BA397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F5F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5258_1607",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.69 44.69) rotate(90) scale(39.7603)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#1BA397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F5F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionBranch);
export default __webpack_public_path__ + "static/media/optionBranch.23d83b91191209c3404b7ab58d641014.svg";
export { ForwardRef as ReactComponent };